import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"
import dayjs from "dayjs"

import { getBinderNumber, getClaimFact, formatDate } from "./helpers"

const header = [["Subject: Claims Paid Bordereaux"], []]

const subheader = [
	"Binder Number",
	"Claim No.",
	"Assured's Name",
	"Policy Number",
	"Loss Type",
	"Loss Date",
	"Currency",
	"Loss Amount",
	"Reserve Amount",
	"Settled Amount",
	"Adjuster/Legal Fee",
	"Premium Bord."
]

/****************** Define Rows ******************/
const rows = fetchedData => {
	let output = []

	let binderGroup = {}

	fetchedData?.reverse()?.map(claim => {
		const policy = claim?.policy
		// create an object and group all policies into seperate arrays by binderNumber
		const binderNumber = getBinderNumber(policy)
		if (!binderNumber) return
		if (!Object.keys(binderGroup).includes(binderNumber)) {
			binderGroup[binderNumber] = []
		}
		binderGroup[binderNumber].push(claim)
	})

	// iterate over values in binderGroup and push to output
	let binderGroupValues = Object.values(binderGroup)
	binderGroupValues.map(group => {
		output.push(subheader)
		group.map(claim => {
			const policy = claim?.policy
			const binderNumber = getBinderNumber(policy)
			output.push([
				binderNumber,
				claim?.issuerNumber,
				policy?.insured?.[0]?.name,
				policy?.issuerNumber,
				getClaimFact("causeOfLoss", "stringValue", claim),
				getLossDate(claim),
				getClaimFact("lossAmountCurrency", "stringValue", claim),
				getClaimFact("lossAmount", "numberValue", claim),
				claim?.totalValues?.approvedAmount,
				claim?.transactions?.[0]?.amount ? claim?.transactions?.[0]?.amount : 0, //TODO: find transaction based on dateTime
				"",
				""
			])
		})
		output.push([], ...getCurrencyTotal(group), [], [])
	})

	return output
}

/****************** Helper Functions ******************/

const getCurrencyTotal = group => {
	let output = []

	// group data by currencyCode
	let groupedData = {}
	group.map(claim => {
		const currencyCode = getClaimFact(
			"lossAmountCurrency",
			"stringValue",
			claim
		)
		if (!Object.keys(groupedData).includes(currencyCode)) {
			groupedData[currencyCode] = []
		}
		groupedData[currencyCode].push(claim)
	})

	Object.values(groupedData)?.map((group, index) => {
		const totalLossAmount = group?.reduce((sum, claim) => {
			const value = getClaimFact("lossAmount", "numberValue", claim)
			return sum + value
		}, 0)
		const totalReservedAmount = group?.reduce((sum, claim) => {
			const value = claim?.totalValues?.approvedAmount
			return sum + value
		}, 0)
		const totalSettledAmount = group?.reduce((sum, claim) => {
			const value = claim?.transactions?.[0]?.amount
				? claim?.transactions?.[0]?.amount
				: 0
			return sum + value
		}, 0)
		output.push([
			"",
			"",
			"",
			"",
			"",
			index === 0 ? "Total" : "",
			Object.keys(groupedData)[index],
			totalLossAmount,
			totalReservedAmount,
			totalSettledAmount,
			"",
			""
		])
	})
	return output
}

const getLossDate = claim => {
	const date = getClaimFact("lossDate", "dateValue", claim)
		? getClaimFact("lossDate", "dateValue", claim)
		: null
	return date ? formatDate(date) : ""
}

/****************** Function for fetching ******************/
const fetchClaims = async filterPayload => {
	const dateFrom = filterPayload?.createdAt?.after
		? dayjs(filterPayload?.createdAt?.after).format()
		: null
	const dateTo = filterPayload?.createdAt?.before
		? dayjs(filterPayload?.createdAt?.before)
				.add(1, "day")
				.format()
		: null

	const query = gql`
		query fetchClaims($claimWhere: claimWhereInput) {
			claims(where: $claimWhere) {
				list {
					policy {
						insured {
							name
						}
						associatedContracts {
							contract {
								facts {
									type
									value {
										stringValue
										dateValue
									}
								}
								startDate
							}
						}
						issuerNumber
						facts {
							type
							value {
								stringValue
								dateValue
							}
						}
						contractHolder {
							name
						}
					}
					issuerNumber
					facts {
						type
						value {
							stringValue
							dateValue
							numberValue
						}
					}
					status
					transactions {
						facts {
							type
							value {
								stringValue
								numberValue
								dateValue
							}
						}
						amount
						dateTime
						currencyCode
					}
					totalValues {
						approvedAmount
						approvedCurrency
					}
				}
			}
		}
	`
	const variables = {
		claimWhere: {
			createdAt_gt: dateFrom,
			createdAt_lt: dateTo,
			status: "APPROVED"
		}
	}

	const res = await api({ query, variables })
	//TODO: error handling
	return res?.data?.claims?.list
}

/****************** Export ******************/
export default async filterPayload => {
	const fetchedData = await fetchClaims(filterPayload)
	const workSheetData = [...header, ...rows(fetchedData)]
	const workSheetColumns = subheader?.map(item => ({ wpx: 200 }))
	return { workSheetData, workSheetColumns }
}
